import React from 'react';

const StaticText = ({ texts }) => {
  const textArray = Array.isArray(texts) ? texts : [texts];

  return (
    <>
      {textArray.map((line, index) => (
        <p key={index}>{line}</p>
      ))}
    </>
  );
};

export default StaticText;
